import { format } from "date-fns";
import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { handleGetBlogBySlug } from "../../../Service/service";
import { BlogType } from "../../../Types/types";
import Blogs from "./Blogs";
import { motion } from "motion/react";
import { FaUser } from "react-icons/fa";
import { FaCalendarDays } from "react-icons/fa6";
import ErrorPage from "../../ErrorPage";
import Markdown from "react-markdown";
import rehypeRaw from "rehype-raw";

const BlogDetailPage = () => {
  const location = useLocation();
  const { slug } = useParams<{ slug: string }>();
  const [blog, setBlog] = useState<BlogType | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBlog = async () => {
      try {
        const data = await handleGetBlogBySlug(slug as string);
        if (!data.data) {
          throw new Error("Blog not found");
        }
        setBlog(data.data);
      } catch (error) {
        console.error("Error fetching blog:", error);
        setBlog(null);
      } finally {
        setLoading(false);
      }
    };

    if (location.state?.blog) {
      setBlog(location.state.blog);
      setLoading(false);
    } else {
      fetchBlog();
    }
  }, [slug, location.state]);

  useEffect(() => {
    if (!blog) return;

    document.title = blog.title;

    const updateMetaTag = (name: string, content: string) => {
      let metaTag = document.querySelector(`meta[name='${name}']`);
      if (!metaTag) {
        metaTag = document.createElement("meta");
        metaTag.setAttribute("name", name);
        document.head.appendChild(metaTag);
      }
      metaTag.setAttribute("content", content);
    };

    updateMetaTag("description", blog.description);
    updateMetaTag("keywords", "John Bostjancic Blog");

    let linkTag = document.querySelector(
      "link[rel='canonical']"
    ) as HTMLLinkElement;
    if (!linkTag) {
      linkTag = document.createElement("link");
      linkTag.rel = "canonical";
      document.head.appendChild(linkTag);
    }
    linkTag.href = `https://johnbostjancic.co/blog/${blog.slug}`;
    console.log("changing")
  }, [blog]);

  if (loading) return <div>Loading...</div>;
  if (!blog) return <ErrorPage />;
  return (
    <>
      <div className="max-w-screen-2xl mx-auto px-5 lg:px-20">
        <div className="lg:h-[450px] bg-[#e6e0ff] lg:bg-transparent lg:bg-bg2 bg-cover lg:bg-contain bg-no-repeat xl:bg-cover lg:-mt-20 xl:-mt-28 relative rounded-b-[50px] rounded-t-[50px] lg:rounded-t-none">
          <div className="w-full h-full flex flex-col justify-center xl:justify-end px-4 xl:px-10 pb-8 xl:pb-14 pt-8 lg:pt-0">
            <div className="flex sm:justify-center sm:items-center">
              <div className="lg:w-[70%] sm:text-center flex flex-col justify-center sm:items-center">
                <motion.div
                  initial={{ y: -100, opacity: 0 }}
                  whileInView={{ y: 0, opacity: 1 }}
                  transition={{ duration: 0.5 }}
                  viewport={{ once: true }}
                  className="py-3 px-4 montserrat-medium text-primary bg-white rounded-full w-32 flex justify-center mb-5"
                >
                  BLOG
                </motion.div>
                <motion.h1
                  initial={{ y: -100, opacity: 0 }}
                  whileInView={{ y: 0, opacity: 1 }}
                  transition={{ duration: 0.5, delay: 0.5 }}
                  viewport={{ once: true }}
                  className="text-secondary text-3xl lg:text-4xl xl:text-5xl montserrat-semibold mb-4"
                >
                  {blog.title}
                </motion.h1>
                <motion.div className="flex flex-col sm:flex-row gap-2 sm:gap-10 items-start">
                  <motion.div className="flex gap-3 justify-center items-center text-primary">
                    <FaUser className="text-primary" /> {blog.author}
                  </motion.div>
                  <motion.div className="flex gap-3 justify-center items-center text-primary">
                    <FaCalendarDays className="text-primary" />
                    {format(new Date(blog.createdAt), "MMMM dd, yyyy")}
                  </motion.div>
                </motion.div>
              </div>
            </div>
          </div>
          <a
            href="/contact"
            className="hidden lg:block bg-[#E9FF7A] py-3 px-7 absolute top-3 xl:top-10 right-5 xl:right-20 2xl:right-24 montserrat-medium rounded-full text-xl z-30"
          >
            Contact Us
          </a>
        </div>
      </div>
      <div className="w-full flex flex-col justify-center items-center">
        <div className="px-5 sm:px-20 pt-10 w-full max-w-screen-2xl">
          <div className="mt-4 rounded-3xl overflow-hidden sm:w-full flex justify-center">
            <img
              className="mb-8"
              src={`https://admin.techqilla.com${blog.image.url}`}
              alt={blog.imageAlt}
            />
          </div>
          <div className="mt-4">
            <Markdown rehypePlugins={[rehypeRaw]}>{blog.content}</Markdown>
          </div>
        </div>
        <div className="">
          <Blogs fromDetailPage />
        </div>
      </div>
    </>
  );
};

export default BlogDetailPage;
